import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { Subject } from "rxjs";
import { decryptResponse } from "src/app/core/constants/constants";
import { encryptData } from "src/app/pages/card-processing/card.util";

import { ExpiryDateFormatterPipe } from "src/app/pages/card-processing/expiry-date-formatter.pipe";

@Component({
    selector: "app-recurring-card-payment",
    templateUrl: "./recurring-card-payment.component.html",
    styleUrls: ["./recurring-card-payment.component.scss"],
    standalone: false
})
export class RecurringCardPaymentComponent implements OnInit {
  cardNumber: string = "";
  cardPin: number;

  expiryDate: any;
  cvv: any;

  clientId: string;
  clientRef: string;

  decryptedValue: any;
  destroy$ = new Subject();

  message: string;
  showModal: boolean;

  cardResponse: any;
  otp: any;

  cardDetails: any;

  @Output() emitCardPayment = new EventEmitter();

  constructor(
    private expdate: ExpiryDateFormatterPipe,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.clientId = param.clientId;
      this.clientRef = param.ref;
    });

    this.route.queryParams.subscribe((param) => {
      this.decryptedValue = decryptResponse(param.q);
    });
  }

  formatExpDate(exp) {
    this.expiryDate = this.expdate.transform(exp);
  }

  allowNumericKeys(event: KeyboardEvent) {
    if (event.charCode < 43 || event.charCode > 57) {
      event.preventDefault();
    }
  }

  async sendData() {
    const payload = {
      reference: `${Date.now().toString()}${Math.floor(Math.random() * 900)}`,
      amount: this.decryptedValue.amount,
      customerId: this.decryptedValue.customerId,
      clientId: this.clientId,
      customer: {
        firstName: this.decryptedValue.firstName,
        lastName: this.decryptedValue.lastName,
        email: this.decryptedValue.email,
        phoneNumber: this.decryptedValue.phoneNumber,
      },
      planReference: this.decryptedValue.planReference,
      cardDetails: {
        authDataVersion: "1",
        pan: this.cardNumber.replace(/\s/g, ""),
        expiryDate: this.expiryDate.replace(/\\|\//g, ""),
        cvv2: this.cvv,
        pin: this.cardPin,
      },
    };

    this.cardDetails = payload.cardDetails;
    const encryptedRequest = {
      reference: payload.reference,
      amount: payload.amount,
      clientId: payload.clientId,
      customerId: payload.customer.email,
      cardDetails: payload.cardDetails,
    };

    const req = {
      reference: payload.reference,
      clientId: this.clientId,
      customer: {
        firstName: this.decryptedValue.firstName,
        lastName: this.decryptedValue.lastName,
        subscriberName:
          this.decryptedValue.firstName + " " + this.decryptedValue.lastName,
        email: this.decryptedValue.email,
        phoneNumber: this.decryptedValue.phoneNumber,
        address: this.decryptedValue.address,
      },
      planReference: payload.planReference,

      authorization: {
        channel: "Card",
        // provider: "Habari",
        provider: "nibssmandate",
        narration: this.decryptedValue.planName,
        ...(await encryptData(encryptedRequest)),
      },
    };

    const instalmentReq = {
      reference: payload.reference,
      planReference: payload.planReference,
      clientId: this.clientId,
      channel: "CARD",
      customer: {
        subscriberName:
          this.decryptedValue.firstName + " " + this.decryptedValue.lastName,
        email: this.decryptedValue.email,
        phoneNumber: this.decryptedValue.phoneNumber,
        address: this.decryptedValue.address,
      },
      authorization: {
        // "provider": "nibssmandate",
        narration: this.decryptedValue.planName,
        ...(await encryptData(encryptedRequest)),
      },
    };

    this.emitCardPayment.emit({
      req,
      cardDetails: payload.cardDetails,
      instalmentReq,
    });
  }
}
